import { CartItem } from './CartItem';
import { useCartConfirmDrawer } from './model/useCartConfirmDrawer';

export const CartItems = () => {
    const items = useCartConfirmDrawer(state => state.items);

    return (
        <ul className="basket-item-list">
            {items.map(item => (
                <CartItem {...item} key={item.sku} />
            ))}
        </ul>
    );
};
